import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  addrouteAndRateAPI,
  getAllCountryList,
  getManagerRatePriceList,
  getRouteList,
  getRouteWiseCountryList,
} from "../../api/api";
import { token, type, userid } from "../../component/common/AdminAuth";

const countrySelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "42px",
    borderRadius: "0.375rem",
    borderColor: state.isFocused ? "#696cff" : "#d9dee3",
    boxShadow: state.isFocused ? "0 0 0 0.05rem rgba(105, 108, 255, 0.25)" : "none",
    "&:hover": { borderColor: "#696cff" },
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "rgba(105, 108, 255, 0.12)",
    borderRadius: "0.375rem",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#696cff",
    fontWeight: 500,
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#696cff",
    "&:hover": { backgroundColor: "#696cff", color: "#fff" },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#696cff"
      : state.isFocused
        ? "rgba(105, 108, 255, 0.12)"
        : "#fff",
    color: state.isSelected ? "#fff" : "#4b5563",
  }),
  menu: (base) => ({ ...base, zIndex: 20 }),
};

function AddUserRatePopup(props) {
  const [countryList, setCountryList] = useState();
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [margin, setMargin] = useState("");
  const [route, setRoute] = useState();
  const [managerPriceList, setManagerPriceList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, seterror] = useState({
    errarStatus: false,
    errorMessage: "",
    bgcolor: "",
  });

  const [data, setData] = useState({
    price: "",
    country_code: "",
    route: "",
    route_id: "",
    status: "1",
    method: "add",
    buy_price: "",
    margin: "",
    system_id: props.selectedSystemID,
    allow_route: props.allow_route,
    user_id: userid,
    token: token,
    type: type,
  });

  const isRestrictedManager =
    type === "Manager" && Number(data.allow_route) === 0;

  useEffect(() => {
    if (type === "Manager" && Number(props.allow_route) === 0) {
      getManagerRatePriceList(userid).then((res) => {
        if (res.data.success === true) {
          setManagerPriceList(res.data.data);
          const uniqueRoutes = [];
          const seenRouteIds = new Set();
          res.data.data.forEach((item) => {
            if (!seenRouteIds.has(item.route_id)) {
              seenRouteIds.add(item.route_id);
              uniqueRoutes.push({ id: item.route_id, title: item.route_name });
            }
          });
          setRoute(uniqueRoutes);
        }
      });
    } else {
      getRouteList().then((res) => {
        setRoute(res.data.data);
      });
    }
    setData((prev) => ({
      ...prev,
      system_id: props.selectedSystemID,
      allow_route: props.allow_route,
    }));
  }, [props.selectedSystemID, props.allow_route]);

  useEffect(() => {
    if (props.type === "edit" && props.editData) {
      let Newdata = { ...data };
      Newdata.country_code = props.editData.country_code;
      Newdata.price = props.editData.selling_price;
      Newdata.buy_price = props.editData.buy_price;
      Newdata.route = props.editData.route_name;
      Newdata.route_id = props.editData.route_id;
      Newdata.method = "update";
      Newdata.id = props.editData.id;
      Newdata.system_id = props.selectedSystemID;
      setMargin(props.editData.margin ?? "");
      routeWiseCountryList(props.editData.route_name);
      setData(Newdata);
    }
  }, [props.editData]);

  const isMultiCountry = selectedCountries.length > 1;

  const addrouteAndRate = () => {
    if (!selectedCountries.length) {
      seterror({
        errarStatus: true,
        errorMessage: "Please select at least one country",
        bgcolor: "alert alert-danger",
      });
      return;
    }

    if (!margin) {
      seterror({
        errarStatus: true,
        errorMessage: "Please enter margin",
        bgcolor: "alert alert-danger",
      });
      return;
    }

    setIsLoading(true);

    const requests = selectedCountries.map((option) => {
      const sellingPrice = (
        parseFloat(option.sellingPrice || 0) *
        (1 + parseFloat(margin || 0) / 100)
      ).toFixed(2);

      return addrouteAndRateAPI({
        ...data,
        country_code: option.countryCode,
        buy_price: option.sellingPrice,
        price: sellingPrice,
        margin,
        method: "add",
      });
    });

    Promise.all(requests)
      .then((results) => {
        const failed = results.find((res) => res.data.success !== true);
        if (!failed) {
          seterror({
            errarStatus: true,
            errorMessage: "Rate added successfully",
            bgcolor: "alert alert-success",
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          seterror({
            errarStatus: true,
            errorMessage: failed.data.message,
            bgcolor: "alert alert-danger",
          });
          setIsLoading(false);
        }
      })
      .catch(() => {
        seterror({
          errarStatus: true,
          errorMessage: "Something went wrong",
          bgcolor: "alert alert-danger",
        });
        setIsLoading(false);
      });
  };

  const update = () => {
    setIsLoading(true);
    addrouteAndRateAPI({ ...data, margin }).then((res) => {
      if (res.data.success === true) {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-success",
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-danger",
        });
        setIsLoading(false);
      }
    });
  };

  const handleMarginChange = (value) => {
    setMargin(value);
    if (selectedCountries.length === 1) {
      const sellingPrice = parseFloat(selectedCountries[0].sellingPrice || 0);
      const computed = value
        ? (sellingPrice * (1 + parseFloat(value) / 100)).toFixed(2)
        : "";
      setData((prev) => ({ ...prev, price: computed, margin: value }));
    } else {
      setData((prev) => ({ ...prev, margin: value }));
    }
  };

  const getCountryList = (id) => {
    getAllCountryList(id).then((res) => {
      setCountryList(res.data.data);
      setSelectedCountries([]);
      setMargin("");
      setData((prev) => ({ ...prev, margin: "", price: "" }));
    });
  };

  const routeWiseCountryList = (id) => {
    getRouteWiseCountryList(id).then((res) => {
      setCountryList(res.data.data);
    });
  };

  const countryOptions = (countryList || []).map((items, i) => ({
    value: i,
    label: `${items.country_name} (${items.country_code})`,
    countryCode: items.country_code,
    countryName: items.country_name,
    sellingPrice: items.selling_price,
  }));

  useEffect(() => {
    if (props.type === "edit" && data.country_code && !selectedCountries.length) {
      const match = countryOptions.find(
        (opt) => opt.countryCode === data.country_code
      );
      if (match) setSelectedCountries([match]);
    }
  }, [countryList]);

  return (
    <>
      <div
        className="modal fade"
        id="userRateModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="userRateModalTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="userRateModalTitle">
                {props.type === "edit" ? "Update" : "Add"} Rate for{" "}
                <span className="text-success">{props.selectedSystemID} </span>
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body row">
              <div className="col-md-12">
                {error.errarStatus ? (
                  <div className={error.bgcolor} role="alert">
                    <strong>Alert!</strong> {error.errorMessage}
                    <button
                      type="button"
                      className="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                ) : null}
              </div>

              <div className="form-group col-md-6">
                {route && (
                  <select
                    value={data.route}
                    onChange={(e) => {
                      var index = e.target.selectedIndex;
                      var optionElement = e.target.childNodes[index];
                      var id = optionElement.getAttribute("data-id");
                      setData({
                        ...data,
                        route: e.target.value, route_id: id
                      });

                      if (isRestrictedManager) {
                        setCountryList(
                          managerPriceList.filter(
                            (item) => String(item.route_id) === String(id)
                          )
                        );
                        setSelectedCountries([]);
                        setMargin("");
                      } else {
                        getCountryList(id);
                      }
                    }}
                    className="form-select"
                  >
                    <option>Select Route</option>
                    {route.map((items, i) => (
                      <option key={i} data-id={items.id} value={items.title}>
                        {items.title}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              <div className="form-group col-md-6">
                <Select
                  isMulti
                  isSearchable
                  closeMenuOnSelect={false}
                  options={countryOptions}
                  value={selectedCountries}
                  onChange={(selected) => setSelectedCountries(selected || [])}
                  placeholder="select countries"
                  noOptionsMessage={() => "No countries found"}
                  styles={countrySelectStyles}
                  classNamePrefix="country-select"
                />
              </div>

              {isMultiCountry ? (
                <div className="form-group d-flex align-items-center col-md-12">
                  <label className="w-25 m-0">Margin</label>
                  <input
                    placeholder="Enter margin %"
                    className="form-control"
                    value={margin}
                    type="number"
                    onChange={(e) => handleMarginChange(e.target.value)}
                  />
                </div>
              ) : (
                <>
                  {selectedCountries.length > 0 && (
                    <div className="form-group col-md-12">
                      <label className="m-0">Selling Price</label>
                      <ul className="mb-0 pl-4">
                        {selectedCountries.map((option) => (
                          <li key={option.value}>
                            {option.label}: {option.sellingPrice}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <div className="form-group d-flex align-items-center col-md-6">
                    <label className="w-50 m-0">Margin</label>
                    <input
                      placeholder="Enter margin %"
                      className="form-control"
                      value={margin}
                      type="number"
                      onChange={(e) => handleMarginChange(e.target.value)}
                    />
                  </div>

                  <div className="form-group d-flex align-items-center col-md-6">
                    <label className="w-50 m-0">Selling Price</label>
                    <input
                      placeholder="Enter price"
                      className="form-control"
                      value={data.price}
                      type="number"
                      disabled
                    />
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              {!(props.type !== "edit" && isMultiCountry) && (
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              )}
              {isLoading ? (
                <button type="button" className="btn btn-primary">
                  Loading.....
                </button>
              ) : (
                <>
                  {props.type === "edit" ? (
                    <button
                      onClick={update}
                      type="button"
                      className="btn btn-primary"
                    >
                      Update
                    </button>
                  ) : isMultiCountry ? (
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={!margin}
                      data-toggle="modal"
                      data-target="#userRatePreviewModal"
                    >
                      Preview
                    </button>
                  ) : (
                    <button
                      onClick={addrouteAndRate}
                      type="button"
                      className="btn btn-primary"
                    >
                      Add
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="userRatePreviewModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="userRatePreviewModalTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="userRatePreviewModalTitle">
                Preview Rates for{" "}
                <span className="text-success">{props.selectedSystemID} </span>
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {error.errarStatus ? (
                <div className={error.bgcolor} role="alert">
                  <strong>Alert!</strong> {error.errorMessage}
                  <button
                    type="button"
                    className="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              ) : null}
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Country Code</th>
                      <th>Country Name</th>
                      <th>Buying Price</th>
                      <th>Selling Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedCountries.map((option) => (
                      <tr key={option.value}>
                        <td>{option.countryCode}</td>
                        <td>{option.countryName}</td>
                        <td>{option.sellingPrice}</td>
                        <td>
                          {(
                            parseFloat(option.sellingPrice || 0) *
                            (1 + parseFloat(margin || 0) / 100)
                          ).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Back
              </button>
              {isLoading ? (
                <button type="button" className="btn btn-primary">
                  Loading.....
                </button>
              ) : (
                <button
                  onClick={addrouteAndRate}
                  type="button"
                  className="btn btn-primary"
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddUserRatePopup;
